import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import SendIcon from '@mui/icons-material/Send';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import DialogTitle from '@mui/material/DialogTitle';
import { Document, Page, Text, StyleSheet, View, Image,PDFDownloadLink ,PDFViewer ,Font ,Svg, pdf } from '@react-pdf/renderer';
import { Grid, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { number } from 'prop-types';
import apiClient from '../ApiClient/ApiClient';
import { resolveStorageVendor } from './vendorSelection';


const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);


const columns = [
  { field: 'id', headerName: 'ID', width: 20 },
  {
    field: '單號',
    headerName: '單號',
    width: 110,
    editable: false,
  },
  {
    field: '序',
    headerName: '序',
    width: 60,
    editable: false,
  },
  {
    field: '廠商',
    headerName: '廠商',
    width: 100,
    editable: false,
  },
];

const detailColumns = [
    
    {
      field: '圖號',
      headerName: '圖號',
      width: 130,
      editable: false,
    },
    {
      field: '物品名',
      headerName: '物品名',
      width: 150,
      editable: false,
    },
    {
      field: '單位',
      headerName: '單位',
      width: 80,
      editable: false,
    },
    {
        field: '數量',
        headerName: '數量',
        width: 120,
        editable: false,
      },
      {
        field: '單價',
        headerName: '單價',
        width: 100,
        editable: false,
        valueFormatter: (params) => {
          // 確保單價顯示到小數點後兩位
          return params.value ? parseFloat(params.value).toFixed(2) : '0.00';
        },
      },
      {
        field: '金額',
        headerName: '金額',
        width: 150,
        editable: false,
        valueFormatter: (params) => {
          // 確保金額顯示為整數
          return params.value ? Math.round(params.value) : '0';
        },
      },
      
      {
        field: '批號',
        headerName: '批號',
        width: 150,
        editable: false,
      },
      { field: 'id', headerName: 'ID', width: 20 },
  ];

  const toYMD = (val) => {
    if (!val) return '';
    // 常見格式：'2025-06-07 16:06:00' / '2025/06/07' / Date 物件
    const s = String(val);
    // 先切掉時間
    const head10 = s.slice(0, 10).replace(/\//g, '-'); // -> 'YYYY-MM-DD'
    // 簡單檢查
    if (/^\d{4}-\d{2}-\d{2}$/.test(head10)) return head10;
  
    // 嘗試用 Date 解析
    const d = new Date(val);
    if (Number.isNaN(d)) return '';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

export default function StorageWork() {
    const [rows,setRows] = React.useState([]);
    const [originalInvoiceNo, setOriginalInvoiceNo] = React.useState(''); // ← 新增
    const [month, setMonth] = React.useState(() => {
      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // 月份是从0开始的
      let dd = today.getDate();
    
      // 如果月份和日期小于10，前面添加0
      if (mm < 10) {
        mm = `0${mm}`;
      }
      if (dd < 10) {
        dd = `0${dd}`;
      }
    
      return `${yyyy}-${mm}-${dd}`;
    });
    const [orderNo,setoOderNo] = React.useState('');
    const [seletedRow,setSelectedRow] = React.useState([]);
    const [selectedOption, setSelectedOption] =React.useState(null);
    const [options, setOptions] = React.useState([]);
    const [detail,setDetail] = React.useState({
        圖號:'',
        物品名:'',
        單位:'',
        數量:'',
        單價:'',
        金額:'',
        批號:'',
    });
    const today = new Date();
    const defaultMonth = `${today.getFullYear()}/${String(today.getMonth() + 1).padStart(2, '0')}`;

    const [selectedInfo,setSelectedInfo] = React.useState({
        入庫日期:'',
        採購單號:'',
        廠商:'',
        對帳月份:defaultMonth,
        入庫類別:'入庫',
        序號:'',
        發票號碼:'',
    });
    const [open, setOpen] = React.useState(false);
    const [openPdf, setPdfOpen] = React.useState(false);

    const handlePdfClickOpen = () => {
      setPdfOpen(true);
    };

    const handlePdfClose = () => {
      setPdfOpen(false);
    };

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    // 只輸出 YYYY-MM-DD，其他情況回傳空字串

    const handleReturn = async () => {
      if (originalInvoiceNo && originalInvoiceNo.trim() !== '') {
        alert('此單已有發票號碼，禁止退庫/刪除。');
        return;
      }

      // 先抓 sessionStorage 的操作者 Id
      const operatorIdStr = sessionStorage.getItem('Id');
      const operatorId = operatorIdStr ? Number(operatorIdStr) : null;
    
      // 從畫面上取單號：優先用右側基礎欄位的採購單號，沒有就用上方單號查詢框
      const returnOrderNo = (selectedInfo?.採購單號 || orderNo || '').trim();
    
      if (!operatorId) {
        alert('找不到操作者 Id，請重新登入或檢查 sessionStorage。');
        return;
      }
      if (!returnOrderNo) {
        alert('請先選擇或輸入要退庫的單號。');
        return;
      }
    
      // 這裡用 POST body 傳，如果你後端要 querystring，留言底下有備用寫法
      const payload = {
        orderNo: returnOrderNo,
        operatorId,
      };
    
      try {
        const res = await apiClient.post(`/Storage/ReturnInStock`, payload);
        // 成功後可刷新右側明細或列表
        await handleDetailSearch(); // 用目前的 orderNo 重新查一次
        alert('退庫成功');
      } catch (err) {
        console.error('Return error:', err);
        alert('退庫失敗，請稍後再試或檢查後端日誌。');
      }
    };
    
    React.useEffect(() => {
      const current = (selectedInfo?.廠商 ?? '').trim();
      if (!current && Array.isArray(seletedRow) && seletedRow.length > 0) {
        const fallback = (seletedRow[0]?.廠商 ?? '').toString().trim();
        if (fallback) {
          setSelectedInfo(prev => ({ ...prev, 廠商: fallback }));
        }
      }
    }, [seletedRow]); // 只在明細改變時嘗試回填
    


    const applySourceVendor = (originalName) => {
      const resolved = resolveStorageVendor(options, originalName);
      setSelectedOption(resolved.option);
      setSelectedInfo(prev => ({ ...prev, 廠商: resolved.name }));
      if (resolved.warning) alert(resolved.warning);
    };

    const handleCellClick = (params) => {
      const r = params.row;
    
      // 取得日期/月份（含入庫List 的後備來源）
      const ymd = toYMD(r?.日期 || r?.入庫List?.[0]?.日期);
      const monthStr = (r?.對帳月份 || r?.入庫List?.[0]?.對帳月份 || '').toString().trim();
    
      setSelectedInfo(prev => ({
        ...prev,
        入庫日期 : ymd || prev.入庫日期 || '',
        採購單號 : r?.單號 ?? prev.採購單號,
        對帳月份 : monthStr || prev.對帳月份,
        入庫類別 : r?.類別 || prev.入庫類別 || '入庫',
        序號     : r?.序 ?? prev.序號,
        廠商     : r?.廠商 ? String(r.廠商).trim() : (prev.廠商 || ''),
        發票號碼 : r?.發票no ? String(r.發票no) : (prev.發票號碼 || ''),
      }));
    
      const inv = (Array.isArray(r?.入庫List) && r.入庫List[0]?.發票no)
        ? String(r.入庫List[0].發票no)
        : '';
      setOriginalInvoiceNo(inv);
      setSelectedInfo(prev => ({ ...prev, 發票號碼: inv }));
    
      setSelectedRow(Array.isArray(r?.入庫List) ? r.入庫List : []);
    
      applySourceVendor(r?.廠商 ?? r?.入庫List?.[0]?.廠商 ?? '');
    };
    
    


    const handleAddDetail = () => {
        // 根据 selectedRows 的当前长度设置新的 id
        const newId = seletedRow.length + 1;
    
        // 创建一个新的 detail 对象，其中包含新的 id
        const newDetail = {
            ...detail,
            id: newId
        };
    
        // 将新的 detail 对象添加到 selectedRows 数组中
        setSelectedRow([...seletedRow, newDetail]);
    
        // 如果需要，可以在此处重置详细信息
        setDetail({
            圖號: '',
            物品名: '',
            單位: '',
            數量: '',
            單價: '',
            金額: '',
            批號: ''
        });
    };
    const fetchOptions = async () => {
        try {    
          const response = await apiClient.get(`/Manufacturer/list`);
          if (response.status === 200) {
            setOptions(response.data.manufacturers);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
    };

    const handleBaseChange = (field, value) => {
        setSelectedInfo({
            ...selectedInfo,
            [field]: value
        });
    };

    
    const handleSummit = async () => {
      if (originalInvoiceNo && originalInvoiceNo.trim() !== '') {
        alert('此單已有發票號碼，禁止變更與儲存。');
        return;
      }
    
      // 1) 單一真相：優先 selectedOption -> selectedInfo -> 明細第一筆
      const vendor =
        (selectedOption?.manufacturer_AbbreviationName ??
         selectedInfo?.廠商 ??
         (seletedRow?.[0]?.廠商 ?? '')
        ).toString().trim();
    
      if (!vendor) {
        alert('廠商為空，請先選擇廠商再儲存。');
        return;
      }
    
      const operatorIdStr = sessionStorage.getItem('Id');
      const operatorId = operatorIdStr ? Number(operatorIdStr) : null;
    
      // 2) 強制覆蓋 BaseSet.廠商，確保後端一定拿到
      const requestData = {
        BaseSet: { ...selectedInfo, 廠商: vendor },
        Details: seletedRow,
        OperatorId: operatorId,
      };
    
      try {
        const response = await apiClient.post(`/Storage/AddInStock`, requestData);
        if (response.status === 200) {
          handlePurchaseSearch();
          alert('提交成功');
        }
      } catch (error) {
        console.error('Error:', error);
        alert('提交失败');
      }
    };
    

    const handleSearch =async() => {

        try {
            const response= await apiClient.get(`/Storage/GetInStockList?month=${month}`);
        
            if (response.status === 200) {
              alert('查詢成功');
              setRows(response.data)
              // Loading the list must not replace the supplier of the open document.
            } else {
              alert('查詢失败');
            }
          } catch (error) {
            console.error('Failed to add data:', error);
            alert('查詢失败');
          }
    };

      // 加總右側 DataGrid 顯示內容的「金額」
  const totalAmount = React.useMemo(() => {
    return (seletedRow || []).reduce((sum, r) => {
      const v = Number(r?.金額);
      return sum + (Number.isFinite(v) ? v : 0);
    }, 0);
  }, [seletedRow]);

  // 顯示為整數（與欄位 valueFormatter 一致用整數），加上千分位
  const formatInt = (n) =>
    Number.isFinite(n) ? Math.round(n).toLocaleString() : '0';


    const handleDetailSearch = async () => {
      try {
        const response = await apiClient.get(`/Storage/GetInStockDetail?orderNo=${orderNo}`);
    
        if (response.status === 200) {
          setSelectedRow(response.data);
    
          const first = response.data?.[0] ?? null;
          const com = first?.廠商 ? String(first.廠商).trim() : '';
    
          applySourceVendor(com);
    
          // 日期/月份的安全回填（含後備欄位）
          const ymd = toYMD(first?.日期 || first?.入庫日期);
          const monthStr = (first?.對帳月份 || '').toString().trim();
    
          const invstring = first?.發票no ? String(first.發票no) : '';
    
          setSelectedInfo(prev => ({
            ...prev,
            入庫日期 : ymd || prev.入庫日期 || '',
            採購單號 : first?.單號 ?? prev.採購單號,
            對帳月份 : monthStr || prev.對帳月份,
            入庫類別 : first?.類別 || prev.入庫類別 || '入庫',
            序號     : first?.序 ?? prev.序號,
            廠商     : com,
            發票號碼 : invstring || prev.發票號碼 || '',
          }));
    
          setOriginalInvoiceNo(invstring);
          if (invstring.trim() !== '') {
            alert('發票已輸入，資料不可更改');
          }
        } else {
          alert('查詢失败');
        }
      } catch (error) {
        console.error('Failed to add data:', error);
        alert('查詢失败');
      }
    };
    
    

    const handlePurchaseSearch = async (value) => {
      try {
        const response = await apiClient.get(`/Storage/GetDataFromPurchase?orderNo=${value}`);
    
        if (response.status === 200) {
          alert('查詢成功');
          setSelectedRow(response.data);
    
          const list = Array.isArray(response?.data) ? response.data : [];
          const first = list[0] ?? null;
    
          const com = (first?.廠商 ?? '').toString().trim();
          applySourceVendor(com);
    
          // 日期/月份的安全回填（含後備欄位）
          const ymd = toYMD(first?.日期 || first?.入庫日期);
          const monthStr = (first?.對帳月份 || '').toString().trim();
    
          setSelectedInfo(prev => ({
            ...prev,
            入庫日期 : ymd || prev.入庫日期 || '',
            採購單號 : first?.單號 ?? prev.採購單號,
            對帳月份 : monthStr || prev.對帳月份,
            入庫類別 : first?.類別 || prev.入庫類別 || '入庫',
            序號     : first?.序 ?? prev.序號,
            廠商     : com,
            發票號碼 : first?.發票no ? String(first.發票no) : (prev.發票號碼 || ''),
          }));
    
          setOriginalInvoiceNo(''); // 新單可編輯
        } else {
          alert('查詢失败');
        }
      } catch (error) {
        console.error('Failed to add data:', error);
        alert('查詢失败');
      }
    };
    
    

    const handleOptionChange = (event, newValue) => {
      setSelectedOption(newValue);
      setSelectedInfo(prev => ({
        ...prev,
        廠商: newValue?.manufacturer_AbbreviationName
          ? String(newValue.manufacturer_AbbreviationName).trim()
          : '' // 清空也要同步
      }));
    };
    

    React.useEffect(() => {
    fetchOptions();
    }, []); 
    React.useEffect(() => {
    if(selectedOption !== null && selectedOption !== undefined) {
        setSelectedInfo((prevRequest) => ({   
            ...prevRequest,
            廠商: String(selectedOption.manufacturer_AbbreviationName ?? "").trim(),
        })); 
    }
    }, [selectedOption]);
  return (
    <Box sx={{ height: 600, width: '100%', display: 'flex',marginTop:'5%'  }}>
        <Box sx={{ height: 1200, width: '30%'}}>
            <TextField
            style={{width:'50%'}}
            id="standard-search"
            label="月份選擇"
            type="search"
            placeholder='yyyy-MM'
            variant="standard"
            value={month}
            onChange={(e)=>setMonth(e.target.value)}
            />
            <Button variant="contained" endIcon={<SendIcon />} onClick={handleSearch}>
                搜尋
            </Button>
            <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                pagination: {
                    paginationModel: {
                    pageSize: 20,
                    },
                },
                }}
                onCellClick={handleCellClick}
                pageSizeOptions={[20,30,40]}
                disableRowSelectionOnClick
                sx={{ height: 520 }} 
                rowHeight={30}
                columnHeaderHeight={36} 

            />
        </Box>
        <Box sx={{ height: 600, width: '65%',marginLeft:'20px'}}>
            <TextField
            style={{width:'50%'}}
            id="standard-search"
            label="單號查詢"
            type="search"
            variant="standard"
            value={orderNo}
            onChange={(e)=>setoOderNo(e.target.value)}
            />
            <Button variant="contained" endIcon={<SendIcon />} onClick={handleDetailSearch}>
                查詢
            </Button>
            <Grid container spacing={2} style={{marginTop:'20px'}}>
                <Grid item xs={3}>
                  <TextField
                    style={{ width: '70%' }}
                    label="入庫日期"
                    type="date"
                    variant="standard"
                    value={selectedInfo.入庫日期 || ''}          // 💡 不要再調 toYMD
                    onChange={(e) => handleBaseChange('入庫日期', e.target.value)}
                    InputLabelProps={{ shrink: true }}           // 讓 label 不會擋到
                  />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                    style={{width:'70%'}}
                    id="standard-search"
                    label="採購單號"
                    type="search"
                    variant="standard"
                    value={selectedInfo.採購單號}
                    onChange={(e) => handleBaseChange('採購單號', e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            handlePurchaseSearch(e.target.value)
                        }
                    }}
                    />
                </Grid>
                <Grid item xs={3}>
                    <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={selectedOption && !options.includes(selectedOption) ? [selectedOption, ...options] : options}
                            sx={{ width: '100%' }}
                            value={selectedOption}
                            onChange={handleOptionChange}
                            getOptionLabel={(option) => option.manufacturer_Seq+ option.manufacturer_AbbreviationName}
                            renderInput={(params) => <TextField {...params} label="廠商" />}
                        />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                    style={{width:'50%'}}
                    id="standard-search"
                    label="對帳月份"
                    type="search"
                    variant="standard"
                    value={selectedInfo.對帳月份}
                    onChange={(e) => handleBaseChange('對帳月份', e.target.value)}
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControl style={{width:'50%'}}>
                        <InputLabel id="入庫類別-label">入庫類別</InputLabel>
                        <Select
                            labelId="入庫類別-label"
                            id="入庫類別-select"
                            value={selectedInfo.入庫類別 || '入庫'}
                            onChange={(e) => handleBaseChange('入庫類別', e.target.value)}
                        >
                            <MenuItem value="尚未選擇">尚未選擇</MenuItem>
                            <MenuItem value="入庫">入庫</MenuItem>
                            <MenuItem value="外購">外購</MenuItem>
                            <MenuItem value="託外入庫">託外入庫</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={3}>
                    <TextField
                    style={{width:'50%'}}
                    id="standard-search"
                    label="序號"
                    type="search"
                    variant="standard"
                    value={selectedInfo.序號}
                    onChange={(e) => handleBaseChange('序號', e.target.value)}
                    />
                </Grid>
                <Grid item xs={3}>
                    <TextField
                    style={{width:'50%'}}
                    id="standard-search"
                    label="發票號碼"
                    type="search"
                    variant="standard"
                    value={selectedInfo.發票號碼}
                    onChange={(e) => handleBaseChange('發票號碼', e.target.value)}
                    />
                </Grid> 
                <Grid item xs={3}>
                  <TextField
                    style={{ width: '70%' }}
                    label="合計"
                    variant="standard"
                    value={formatInt(totalAmount)}
                    InputProps={{ readOnly: true }}
                    />
                </Grid>   
                <Grid item xs={3}>
                    <Button variant="contained" endIcon={<SendIcon />} onClick={handleSummit}
                    disabled={!!(originalInvoiceNo && originalInvoiceNo.trim() !== '')}>
                    儲存
                    </Button>
                </Grid> 
                <Grid item xs={3}>
                    <Button variant="contained" endIcon={<SendIcon />} onClick={handlePdfClickOpen}>
                    入庫PDF
                    </Button>
                </Grid> 
                <Grid item xs={3}>
                    <Button variant="contained" endIcon={<SendIcon />} onClick={handleClickOpen}>
                    新增
                    </Button>
                </Grid> 
                <Grid item xs={3}>
                    <Button variant="contained" endIcon={<SendIcon />} onClick={handleReturn} 
                    disabled={ (!!(originalInvoiceNo && originalInvoiceNo.trim() !== '')) || (!selectedInfo?.採購單號 && !orderNo) }>
                    退庫
                    </Button>
                </Grid>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                      event.preventDefault();
                      const formData = new FormData(event.currentTarget);
                      const formJson = Object.fromEntries(formData.entries());
                      const email = formJson.email;
                      console.log(email);
                      handleClose();
                    },
                  }}
                >
                <DialogTitle>新增</DialogTitle>
                  <DialogContent>
                  <Grid container spacing={2} style={{marginTop:'20px'}}>
                  <Grid item xs={12}>
                        <TextField
                        style={{width:'50%'}}
                        id="standard-search"
                        label="採購單號 //請按下'ENTER'搜尋"
                        type="search"
                        variant="standard"
                        value={selectedInfo.採購單號}
                        onChange={(e) => handleBaseChange('採購單號', e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') { // 修改這行為檢測 Enter 鍵
                            e.preventDefault(); 
                            handlePurchaseSearch(e.target.value);
                        }
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        style={{ width: '50%' }}
                        label="入庫日期"
                        type="date"
                        variant="standard"
                        value={selectedInfo.入庫日期 || ''}          // 💡 不要在這裡 toYMD
                        onChange={(e) => handleBaseChange('入庫日期', e.target.value)}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                        <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={selectedOption && !options.includes(selectedOption) ? [selectedOption, ...options] : options}
                                sx={{ width: '100%' }}
                                value={selectedOption}
                                onChange={handleOptionChange}
                                getOptionLabel={(option) => option.manufacturer_Seq+ option.manufacturer_AbbreviationName}
                                renderInput={(params) => <TextField {...params} label="廠商" />}
                            />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                        style={{width:'50%'}}
                        id="standard-search"
                        label="對帳月份"
                        type="search"
                        variant="standard"
                        value={selectedInfo.對帳月份}
                        onChange={(e) => handleBaseChange('對帳月份', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl style={{width:'50%'}}>
                            <InputLabel id="入庫類別-label">入庫類別</InputLabel>
                            <Select
                                labelId="入庫類別-label"
                                id="入庫類別-select"
                                value={selectedInfo.入庫類別}
                                onChange={(e) => handleBaseChange('入庫類別', e.target.value)}
                            >
                                <MenuItem value="尚未選擇">尚未選擇</MenuItem>
                                <MenuItem value="入庫">入庫</MenuItem>
                                <MenuItem value="外購">外購</MenuItem>
                                <MenuItem value="託外入庫">託外入庫</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                        style={{width:'50%'}}
                        id="standard-search"
                        label="序號"
                        type="search"
                        variant="standard"
                        value={selectedInfo.序號}
                        onChange={(e) => handleBaseChange('序號', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                        style={{width:'50%'}}
                        id="standard-search"
                        label="發票號碼"
                        type="search"
                        variant="standard"
                        value={selectedInfo.發票號碼}
                        onChange={(e) => handleBaseChange('發票號碼', e.target.value)}
                        />
                    </Grid>   
                    <Grid item xs={12}>
                      <DataGrid
                        rows={seletedRow}
                        columns={detailColumns}
                        initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 20,
                            },
                        },
                        }}
                        pageSizeOptions={[20,30,40]}
                        disableRowSelectionOnClick
                        sx={{ height: 400 }}
                        rowHeight={30}
                        columnHeaderHeight={36} 
                      />   
                    </Grid>  
                  </Grid>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose}>取消</Button>
                    <Button onClick={handleSummit}>新增採購到入庫</Button>
                  </DialogActions>
                </Dialog>    
                    <Dialog
                        fullScreen
                        open={openPdf}
                        onClose={handlePdfClose}
                        TransitionComponent={Transition}
                    >
                        <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handlePdfClose}
                            aria-label="close"
                            >
                            <CloseIcon />
                            </IconButton>
                            <Button autoFocus color="inherit" onClick={handlePdfClose}>
                            列印預覽
                            </Button>
                        </Toolbar>
                        </AppBar>
                        <PDFViewer style={{ width: '100%', height: '100%' }}>
                            {seletedRow.length > 0 ? <MyDocument data={seletedRow} /> : null}
                        </PDFViewer> 
                    </Dialog> 
            </Grid>
            <DataGrid
                rows={seletedRow}
                columns={detailColumns}
                initialState={{
                pagination: {
                    paginationModel: {
                    pageSize: 20,
                    },
                },
                }}
                pageSizeOptions={[20,30,40]}
                disableRowSelectionOnClick
                sx={{ height: 270 }} 
                rowHeight={30} 
                columnHeaderHeight={36}
            />
        </Box>
    </Box>
  );
}



Font.register({
  family: 'TaipeiSansTCBeta-Bold',
  src: 'path/to/TaipeiSansTCBeta-Bold.ttf', // 替换为您的实际字体文件路径
});
Font.register({
  family: 'TaipeiSansTCBeta-Light',
  src: 'path/to/TaipeiSansTCBeta-Light.ttf', // 替换为您的实际字体文件路径
});
// 页面宽高转换为点（1cm = 28.28点）
const pageWidth = 24.1 * 72 / 2.54;
const pageHeight = 14 * 72 / 2.54;

// 表格宽度比例，根据您的表格设计调整
const cellWidth = pageWidth / 6; // 假设有8列

const styles = StyleSheet.create({
  page: {
      flexDirection: 'column',
      backgroundColor: 'white',
      padding: 24,
      width: pageWidth,
      height: pageHeight,
  },
  onePage: {
      flexDirection: 'row',
      backgroundColor: 'white',
      padding: 24,
      width: pageWidth,
      height: pageHeight,
  },
  title: {
      fontSize: 20,
      textAlign: 'center',
      fontFamily: 'TaipeiSansTCBeta-Bold',
      marginBottom: 10,
  },
  smallTitle: {
    fontSize: 10,
    textAlign: 'center',
    fontFamily: 'TaipeiSansTCBeta-Light',
    marginBottom: 10,
  },
  tableContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      fontFamily: 'TaipeiSansTCBeta-Bold', // 新增此行以确保容器内的内容（标题）居中
      width: '100%', // 确保容器宽度充满整个页面或其父容器
  },  
  headerRow: {
    flexDirection: 'row',
    width: '100%', // 确保行宽充满整个页面
    textAlign: 'center', 
    fontFamily: 'TaipeiSansTCBeta-Bold',// 确保文本居中（对于Text组件可能不起作用，需要在Text组件中单独设置）
    marginTop: 5, // 根据需要调整，为标题和标头之间提供一些空间
  },
  headerDashRow: {
    flexDirection: 'row',
    // borderBottomWidth: 1,
    // borderTopWidth: 1,
    // borderLeftWidth: 1,
    // borderRightWidth: 1,
    // borderColor: 'black',
    width: '100%', // 确保行宽充满整个页面
    textAlign: 'center', 
    fontFamily: 'TaipeiSansTCBeta-Bold',// 确保文本居中（对于Text组件可能不起作用，需要在Text组件中单独设置）
    marginTop: 5, // 根据需要调整，为标题和标头之间提供一些空间
  },
  headerBottomRow: {
    flexDirection: 'row',
    width: '100%', // 确保行宽充满整个页面
    textAlign: 'center', 
    fontFamily: 'TaipeiSansTCBeta-Bold',// 确保文本居中（对于Text组件可能不起作用，需要在Text组件中单独设置）
    marginTop: 120, // 根据需要调整，为标题和标头之间提供一些空间
  },
  headerRowDash: {
    flexDirection: 'row',
    width: '100%', // 确保行宽充满整个页面
    textAlign: 'center', 
    fontFamily: 'TaipeiSansTCBeta-Bold',// 确保文本居中（对于Text组件可能不起作用，需要在Text组件中单独设置）
    marginTop: 10, // 标题和标头之间的空间
    // borderTop: 1, // 添加上边框
    // borderBottom: 1, // 添加下边框
    // borderColor: 'black', // 边框颜色
    // paddingTop: 5, // 标头内容与上边框之间的空间
    // paddingBottom: 5, // 标头内容与下边框之间的空间
  },
  headerDashItem: {
    flex: 1, // 平分容器宽度
    textAlign: 'center', // 文本居中
    fontFamily: 'TaipeiSansTCBeta-Light',
    fontSize: 10,
    borderWidth: 1,
    borderColor: 'black',
    paddingTop: 5, // 增加上边距
    paddingBottom: 5, // 增加下边距
},

  headerItem: {
      flex: 1, // 平分容器宽度
      textAlign: 'center', // 文本居中
      fontFamily: 'TaipeiSansTCBeta-Light',
      fontSize: 10,
  },
  header物品名: {
    width: '20%',
    textAlign: 'center', // 文本居中
    fontFamily: 'TaipeiSansTCBeta-Light',
    fontSize: 10,
  }
});


// 创建文档组件 
const MyDocument = ({ data}) => ( 

  <Document>
      <Page size={{ width: 842, height: 595 }} style={styles.page}>
        <View style={styles.tableContainer}>
          <Text style={styles.title}>福蒙精密工業股份有限公司</Text> 
        </View>
        <View style={styles.tableContainer}>
          <Text style={styles.title}>入庫驗收單</Text>
        </View>
        <View style={styles.tableContainer}>
          <Text style={styles.headerItem}>廠商:{data[0].廠商}</Text>
          <Text style={styles.headerItem}>入庫類別:{data[0].類別}</Text>
        </View>
        <View style={styles.tableContainer}>
          <Text style={styles.headerItem}>入庫倉庫:{data[0].memo}</Text>
          <Text style={styles.headerItem}>入庫單號:{data[0].單號}</Text>
        </View>
        <View style={styles.tableContainer}>
          <Text style={styles.headerItem}>序號:{data[0].序}</Text>
          <Text style={styles.headerItem}>入庫日期:{toYMD(data[0]?.日期)}</Text>
        </View>
        <View style={styles.headerDashRow}>
            <Text style={styles.headerDashItem}>圖號</Text>
            <Text style={styles.headerDashItem}>物品名</Text>
            <Text style={styles.headerDashItem}>單位</Text>
            <Text style={styles.headerDashItem}>數量</Text>
            <Text style={styles.headerDashItem}>批號</Text>
        </View>
      {data.map((item, index) => (
      <>
        <View style={styles.headerDashRow}>
            <Text style={styles.headerDashItem}>{item.圖號}</Text>
            <Text style={styles.headerDashItem}>{item.物品名}</Text>
            <Text style={styles.headerDashItem}>{item.單位}</Text>
            <Text style={styles.headerDashItem}>{item.數量}</Text>
            <Text style={styles.headerDashItem}>{item.批號}</Text>
        </View>
        </>     
        ))}
        <View style={styles.headerBottomRow}>
            <Text style={styles.headerItem}>核准:</Text>
            <Text style={styles.headerItem}>審核:</Text>
            <Text style={styles.headerItem}>採購:</Text>
            <Text style={styles.headerItem}>品管:</Text>
            <Text style={styles.headerItem}>倉管:</Text>
        </View>
      </Page>            
  </Document>
);